// config.js
const config = {
  // baseURL: "http://localhost:5000"
  baseURL: "https://api.futureshadi.com"
};

export default config;